export default {
  "claimsList": {
    "clipboardRichText": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktualny status reklamacji sprawdzą Państwo <a href=\"", _interpolate(_named("url")), "\">TUTAJ</a>."])}
  }
}